import React from 'react';

import { Breadcrumb, Container } from 'aplazame-design-system';
import TransitionLink from 'aplazame-design-system/src/components/TransitionLink';

const addLink = (links, title, slug, titleAlt) => {
    links.unshift({
        Tag: TransitionLink,
        scheme: 'gatsby',
        href: `${slug}/`,
        title: title,
        titleAlt
    });

    return links;
}

const addParentLink = (links, treeParent) => {
    links = addLink(links, treeParent.title, treeParent.slug);

    if (treeParent.treeParent) {
        links = addLink(links, treeParent.treeParent.title, treeParent.treeParent.slug);
    }

    return links;
}

export default function BreadcrumbSection({ home, page }) {
    let links = [{ 
        title: page.title 
    }];

    if (page.treeParent) {
        links = addParentLink(links, page.treeParent);
    }

    if (home.id !== page.id) {
        links = addLink(links, 'Aplazame', '', 'Aplazame');
    }

	return (
        <Container>
            <Breadcrumb
                firstFavicon={true}
                links={links}
            />
        </Container>
    );
}